import {commonMethods} from "./common-methods";
import {inquiryMethods} from "./inquiry-methods";
import {createMethods} from "./create-methods";
export default ([state, setState]) => {
    return {
        commonMethods: () => commonMethods([state, setState]),
        createMethods: () => createMethods([state, setState]),
        inquiryMethods: () => inquiryMethods([state, setState])
    }
}